import { useTranslate } from 'hooks/useTranslate';
import { FC, ChangeEvent } from 'react';

type Props = {
  pauseStartDate: string;
  handleChangePauseStartDate: (event: ChangeEvent<HTMLInputElement>) => void;
  isIndefinitePause: boolean;
  handleChangeIsIndefinitePause: (event: ChangeEvent<HTMLInputElement>) => void;
  pauseEndDate: string;
  handleChangePauseEndDate: (event: ChangeEvent<HTMLInputElement>) => void;
};

const PauseBeneficiaryDateSection: FC<Props> = ({
  pauseStartDate,
  handleChangePauseStartDate,
  isIndefinitePause,
  handleChangeIsIndefinitePause,
  pauseEndDate,
  handleChangePauseEndDate,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="start-pause-date">
          {t('StartPauseDate')}
        </label>
        <div className="form-control-wrap">
          <input
            type="date"
            className="form-control date-picker form-control-lg"
            id="start-pause-date"
            value={pauseStartDate}
            onChange={handleChangePauseStartDate}
            required
            max="2100-01-01"
          />
        </div>
      </div>

      <div className="form-group">
        <div className="form-group mt-2">
          <div className="custom-control custom-control-xs custom-checkbox">
            <input
              type="checkbox"
              id="checkbox-indefinite-pause"
              className="custom-control-input"
              checked={isIndefinitePause}
              onChange={handleChangeIsIndefinitePause}
            />
            <label
              className="custom-control-label"
              htmlFor="checkbox-indefinite-pause"
            >
              {t('IndefinitePause')}

              {isIndefinitePause && (
                <div className="form-note mt-1">
                  {t('IndefinitePauseManualNote')}
                </div>
              )}
            </label>
          </div>
        </div>
      </div>

      {!isIndefinitePause && (
        <div className="form-group">
          <label className="form-label" htmlFor="end-pause-date">
            {t('EndPauseDate')}
          </label>
          <div className="form-control-wrap">
            <input
              type="date"
              className="form-control date-picker form-control-lg"
              id="end-pause-date"
              value={pauseEndDate}
              onChange={handleChangePauseEndDate}
              min={pauseStartDate}
              max="2100-01-01"
              required
            />
          </div>
        </div>
      )}

      <hr className="border-muted my-4" />
    </>
  );
};

export default PauseBeneficiaryDateSection;
